// Import packages
import React, {Component, useEffect, useRef, useState} from "react";
import {connect} from "react-redux";
import moment from "moment";
import html2pdf from 'html2pdf.js';
import { toJpeg,} from 'html-to-image';

//import assets
import "./download-workout-schedule.scss"
import "../../../assets/styles/dataDisplay/scheduleTemplate.scss"

// Import components
import {InputGroup} from "../../../components/uiElements/inputGroup";
import {LinkButton} from "../../../components/buttons/buttons";

// Import utils
import {WEEKDAY_TYPES, WORKOUT_TYPE_CONST} from "../../../constants/constsTypes";
import {mapStateToProps} from "../../../redux/mapStateToProps";
import {GetAllGroupWorkoutTimelines} from "../../../redux/actions";
import {localTime, makeUTCTime} from "../../../utils/dateHelper";
import {trainerIds} from "../../../constants/constIds";
import {BackgroundIcon, TemplateLogo} from "../../../assets/images";


const timelineTypeOptions = Object.values(WEEKDAY_TYPES).map(weekday => ({
    id: weekday.key,
    name: weekday.name
}));


function DownloadWorkoutSchedule(props) {
    const {timeline} = props;
    const [workoutTimeLine, setWorkoutTimeLine] = useState(null);
    const [weekday, setWeekday] = useState(WEEKDAY_TYPES.Monday);
    const [loading, setLoading] = useState(false);
    const contentRef = useRef();

    useEffect(() => {
        timeline && processTimeLine()
    }, [timeline]);


    async function processTimeLine() {
        const workoutTimeLine = {}
        Object.keys(WEEKDAY_TYPES).forEach(key => {
            workoutTimeLine[key] = timeline?.filter(item => item.weekday === key && !item?.workout?.is_hidden)
        })
        console.log('workoutTimeLine', workoutTimeLine);
        setWorkoutTimeLine(workoutTimeLine)
    }

    function getWeekDayValue({value}) {
        setWeekday(WEEKDAY_TYPES[value])
    }

    useEffect(() => {
        if (loading) {
            handleDownloadTimelineImage()
        }
    }, [loading]);


    function downloadImage() {
        setLoading(true);
    }

    async function handleDownloadTimelineImage() {
        // setLoading(true)
        // const canvas = await html2canvas(contentRef.current, {
        //     windowWidth: 1500,
        //     windowHeight: 1000,
        //     backgroundColor: "#000000",
        //     x: 1,
        //     width: 739,
        // });
        //
        // const canvasWidth = canvas.width;
        // const canvasHeight = canvas.height;
        //
        // console.log('can - width ', canvasWidth)
        // console.log('can - Height ', canvasHeight)
        //
        // canvas.toBlob((blob) => {
        //     const link = document.createElement('a');
        //     link.href = URL.createObjectURL(blob);
        //     link.download = `${weekday.key}-${moment().format("DD-MM-YYYY")}.jpg`;
        //     link.click();
        //
        //     // Clean up the URL object
        //     URL.revokeObjectURL(link.href);
        //     setTimeout(() => {
        //         setLoading(false)
        //     }, 500)
        // }, 'image/jpg', 0.99);

        toJpeg(contentRef.current, {quality: 0.99}).then(function (dataUrl) {
            var link = document.createElement('a');
            link.download = `${weekday.key}-schedule-${moment().format("DD-MM-YYYY")}.jpg`;
            link.href = dataUrl;
            link.click();
            setTimeout(() => {
                setLoading(false)
            }, 500)
        })
    }

    function renderTimeLineBlock(list, badge) {
        let items = [];
        list?.map((item, index, arr) => {
            const weekAddition = weekday.index;
            const endTimeWeekAddition = weekAddition + (makeUTCTime(item.end_time).hour() === 0 ? 1 : 0)
            const cancellationDate = item?.workout?.workout_cancellations?.find(c => {
                return makeUTCTime(item.start_time).day(weekAddition).valueOf()
                    < moment(c.date).valueOf() && moment(c.date).valueOf() <
                    makeUTCTime(item.end_time).day(endTimeWeekAddition).valueOf()
            })
            if (!cancellationDate) {
                items.push(<div className={'row'} key={item.id}>
                    <span className={'time'}>{localTime(item?.start_time)}</span>
                    <span className={`workout ${item?.workout?.title?.includes('Tennis') ? 'tennis' : ''} 
                    ${item?.workout?.workout_types?.includes(WORKOUT_TYPE_CONST.AQUA) ? 'aqua' : ''} 
                    ${item?.workout?.workout_types?.includes(WORKOUT_TYPE_CONST.CHILDREN) ? 'kids' : ''} `}>
                        {item?.workout?.title}
                    </span>
                      <div className={'trainer'}>
                          {item?.trainers?.length ? <span>Instructor</span> : ''}
                        {
                            item?.trainers?.length ?
                                `${item?.trainers?.map(t => {
                                    const [firstName, lastName] = t?.name?.split(' ');
                                    let name = `${firstName}${trainerIds?.includes(t.id) ? ` ${lastName?.slice(0, 3)}` : ''}`
                                    return name
                                }).join('/')}`
                                : ''}</div>
                    <span className={'hall'}>{item?.room || ""}</span>
                </div>)
            }
        })
        return items
    }

    const adultTimeline = workoutTimeLine?.[weekday.key]?.filter(item => item?.workout?.workout_types?.includes(WORKOUT_TYPE_CONST.ADULT));
    const aquaTimeline = workoutTimeLine?.[weekday.key]?.filter(item => item?.workout?.workout_types?.includes(WORKOUT_TYPE_CONST.AQUA));
    const kidsTimeline = workoutTimeLine?.[weekday.key]?.filter(item => item?.workout?.workout_types?.includes(WORKOUT_TYPE_CONST.CHILDREN));

    console.log('workoutTimeLine', workoutTimeLine);
    console.log('adultTimeline', adultTimeline);
    return <div className={'generate-timeline-wrapper'}>
        <div className={'visible-part'}>
            <div className={'title'}> Ընտրել շաբաթվա օր</div>
            <InputGroup inputType="selectCustom"
                // label="Շաբաթվա օր"
                        placeholder="Ընտրել շաբաթվա օր"
                        name="weekDay"
                        showSearch={false}
                // allowClear={true}
                        value={weekday.key}
                        required={true}
                        onChange={getWeekDayValue}
                        options={timelineTypeOptions}/>
            <LinkButton title={"Download timeline schedule image"}
                        disabled={!workoutTimeLine}
                        loadingWithTitle={true}
                        loading={loading}
                        cb={downloadImage}
                        // cb={handleDownloadPdf}
            />
        </div>
        <div className={`a4_page ${loading ? 'visible' : ''}`} ref={contentRef}>
            <img src={BackgroundIcon}
                 alt="icon"
                 className={'background_image'} />
            <div className={'schedule_template'}>
                <div className="schedule_template-header">
                    <div className={'schedule_template-header-title'}>
                            <p>ՄԱՐԶՈՒՄՆԵՐԻ <span>ԳՐԱՖԻԿ</span></p>
                            <p>WORKOUTS <span>SCHEDULE</span></p>
                    </div>
                </div>
                <div className={'schedule_template_block'}>
                    <div className="schedule_template-weekday-column"
                         style={{backgroundColor: weekday.color}}>
                        <span className="schedule_template-day-label">{weekday.shortName}</span>
                        <strong className="schedule_template-day-number">{weekday.shortNameEn}</strong>
                    </div>
                    <div className={'schedule_block'}>
                        <div className={'th'}>
                            <div className={'th_time'}>
                                Ժամ
                            </div>
                            <div className={'th_training'}>
                                Մարզում
                            </div>
                            <div className={'th_trainer'}>
                                Մարզիչ
                            </div>
                            <div className={'th_lounge'}>
                                Սրահ
                            </div>
                        </div>
                        {renderTimeLineBlock(workoutTimeLine?.[weekday.key])}

                        {/*{renderTimeLineBlock(aquaTimeline, 'aqua')}*/}

                        {/*{renderTimeLineBlock(kidsTimeline, 'kids')}*/}
                    </div>
                </div>
            </div>
        </div>
    </div>

}

const mapDispatchToProps = {
    GetAllGroupWorkoutTimelines,
};

export default connect(mapStateToProps, mapDispatchToProps)(DownloadWorkoutSchedule);
